import {launchDarkly} from "utils/launchDarkly";
import {
    PROCESS_DETAILS_BY_UID_URL_PART,
    PROCESS_DETAILS_URL_PART,
    TASK_DETAILS_BY_UID_URL_PART,
    TASK_DETAILS_URL_PART,
} from "utils/constants";

interface DetailsTarget {
    key?: string;
    uid?: string;
}

export function isDetailsByUidEnabled(): boolean {
    return launchDarkly.userClient?.variation("fe-details-by-uid", false) ?? false;
}

function detailsPath(target: DetailsTarget | undefined, keyPath: string, uidPath: string): string {
    // uid is still optional on task payloads, so fall back to the key route instead of linking nowhere
    if (isDetailsByUidEnabled() && target?.uid) {
        return uidPath + target.uid;
    }
    // no key to fall back to: "" is what the navigation helpers already treat as nowhere to go,
    // where a key path would read /task/undefined
    return target?.key ? keyPath + target.key : "";
}

export function taskDetailsPath(task: DetailsTarget | undefined): string {
    return detailsPath(task, TASK_DETAILS_URL_PART, TASK_DETAILS_BY_UID_URL_PART);
}

export function processDetailsPath(process: DetailsTarget | undefined): string {
    return detailsPath(process, PROCESS_DETAILS_URL_PART, PROCESS_DETAILS_BY_UID_URL_PART);
}
